import { TeacherStatus } from 'constants/common';
import { memo, useEffect, useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Container, AppBar } from '@mui/material';
// config
import { NavSectionHorizontal } from '@onedesign/ui';
import { useProfileService } from 'services/ProfileService';
import { HEADER } from '../../../config';
// components

// config
import getNavConfig, { NavItem } from './NavConfig';
import getUnverifiedNavConfig from './UnverifiedNavConfig';

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar)(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

function NavbarHorizontal() {
  const { profile } = useProfileService();
  const [navConfig, setNavConfig] = useState<
    {
      subheader: string;
      items: NavItem[];
    }[]
  >([]);

  const config = getNavConfig();
  const { configs: unverifiedConfig } = getUnverifiedNavConfig();
  const isTeacherUnverified: boolean =
    profile.status !== '' && profile.status !== undefined
      ? profile.status === TeacherStatus.UNVERIFIED
      : false;

  useEffect(() => {
    if (isTeacherUnverified) {
      setNavConfig(unverifiedConfig);
    } else {
      setNavConfig(config);
    }
  }, [profile, unverifiedConfig, config]);

  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal navConfig={navConfig} />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);
